export const codes = [
  "KeyA",
  "KeyS",
  "KeyD",
  "KeyF",
  "KeyH",
  "KeyG",
  "KeyZ",
  "KeyX",
  "KeyC",
  "KeyV",
  "IntlBackslash",
  "KeyB",
  "KeyQ",
  "KeyW",
  "KeyE",
  "KeyR",
  "KeyY",
  "KeyT",
  "Digit1",
  "Digit2",
  "Digit3",
  "Digit4",
  "Digit6",
  "Digit5",
  "Equal",
  "Digit9",
  "Digit7",
  "Minus",
  "Digit8",
  "Digit0",
  "BracketRight",
  "KeyO",
  "KeyU",
  "BracketLeft",
  "KeyI",
  "KeyP",
  "Enter",
  "KeyL",
  "KeyJ",
  "Quote",
  "KeyK",
  "Semicolon",
  "Backslash",
  "Comma",
  "Slash",
  "KeyN",
  "KeyM",
  "Period",
  "Tab",
  "Space",
  "Backquote",
  "Backspace",
  "Escape",
  "MetaRight",
  "MetaLeft",
  "ShiftLeft",
  "CapsLock",
  "AltLeft",
  "ControlLeft",
  "ShiftRight",
  "AltRight",
  "ControlRight",
  "F17",
  "NumpadDecimal",
  "NumpadMultiply",
  "NumpadAdd",
  "NumLock",
  "AudioVolumeUp",
  "AudioVolumeDown",
  "AudioVolumeMute",
  "NumpadDivide",
  "NumpadEnter",
  "NumpadSubtract",
  "F18",
  "F19",
  "NumpadEqual",
  "Numpad0",
  "Numpad1",
  "Numpad2",
  "Numpad3",
  "Numpad4",
  "Num",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
] as const;

export const codeName = {
  KeyA: "A",
  KeyS: "S",
  KeyD: "D",
  KeyF: "F",
  KeyH: "H",
  KeyG: "G",
  KeyZ: "Z",
  KeyX: "X",
  KeyC: "C",
  KeyV: "V",
  IntlBackslash: "IntlBackslash",
  KeyB: "B",
  KeyQ: "Q",
  KeyW: "W",
  KeyE: "E",
  KeyR: "R",
  KeyY: "Y",
  KeyT: "T",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit6: "6",
  Digit5: "5",
  Equal: "Equal",
  Digit9: "9",
  Digit7: "7",
  Minus: "Minus",
  Digit8: "8",
  Digit0: "0",
  BracketRight: "BracketRight",
  KeyO: "O",
  KeyU: "U",
  BracketLeft: "BracketLeft",
  KeyI: "I",
  KeyP: "P",
  Enter: "Enter",
  KeyL: "L",
  KeyJ: "J",
  Quote: "Quote",
  KeyK: "K",
  Semicolon: "Semicolon",
  Backslash: "Backslash",
  Comma: "Comma",
  Slash: "Slash",
  KeyN: "N",
  KeyM: "M",
  Period: "Period",
  Tab: "Tab",
  Space: "Space",
  Backquote: "Backquote",
  Backspace: "Backspace",
  Escape: "Escape",
  MetaRight: "MetaRight",
  MetaLeft: "MetaLeft",
  ShiftLeft: "ShiftLeft",
  CapsLock: "CapsLock",
  AltLeft: "AltLeft",
  ControlLeft: "ControlLeft",
  ShiftRight: "ShiftRight",
  AltRight: "AltRight",
  ControlRight: "ControlRight",
  F17: "F17",
  NumpadDecimal: "NumpadDecimal",
  NumpadMultiply: "NumpadMultiply",
  NumpadAdd: "NumpadAdd",
  NumLock: "NumLock",
  AudioVolumeUp: "AudioVolumeUp",
  AudioVolumeDown: "AudioVolumeDown",
  AudioVolumeMute: "AudioVolumeMute",
  NumpadDivide: "NumpadDivide",
  NumpadEnter: "NumpadEnter",
  NumpadSubtract: "NumpadSubtract",
  F18: "F18",
  F19: "F19",
  NumpadEqual: "NumpadEqual",
  Numpad0: "Numpad0",
  Numpad1: "Numpad1",
  Numpad2: "Numpad2",
  Numpad3: "Numpad3",
  Numpad4: "Numpad4",
  Num: "Num",
  ArrowUp: "ArrowUp",
  ArrowDown: "ArrowDown",
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
} as const;
